import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { CCol } from '@coreui/react-pro';

import { showPriceProductPage } from '../../../../../utils';
import { COURSE_DIRECT_PATH, GUEST_PATH, SELLING_GROUP_TRAINING_METHOD_LABEL } from '../../../../../constants';

const SellingGroupCard = ({ sellingGroup }) => {
     const descriptionRef = useRef(null);

     const [isFullContent, setIsFullContent] = useState(false);
     const [showButtonView, setShowButtonView] = useState(false);

     const isProductionEnv = process.env.REACT_APP_ENV === 'prod';

     const trainingMethods = useMemo(() => {
          const _trainingMethods = [];

          const trainingMethodPackageExists = sellingGroup.trainingMethods.includes('package');
          if (sellingGroup.package && !trainingMethodPackageExists) {
               _trainingMethods.push('Package');
          }

          sellingGroup.trainingMethods.forEach((trainingMethod) => {
               if (!_trainingMethods.includes(trainingMethod)) {
                    _trainingMethods.push(SELLING_GROUP_TRAINING_METHOD_LABEL[trainingMethod]);
               }
          });

          return _trainingMethods;
     }, [sellingGroup.package, sellingGroup.trainingMethods]);

     useEffect(() => {
          if (!descriptionRef.current) return;

          const firstDescriptionChildren = descriptionRef.current.children[0];
          if (!firstDescriptionChildren) return;

          setShowButtonView(firstDescriptionChildren.scrollHeight !== firstDescriptionChildren.clientHeight);
     }, []);

     const handleClickViewContent = () => {
          setIsFullContent((prevIsFullContent) => !prevIsFullContent);
     };

     const handleClickExplore = () => {
          localStorage.removeItem(COURSE_DIRECT_PATH);
     };

     const bookGroupStagingId = '1474c330-5fca-4e56-a13b-04dfc0b06e88-1655957150689';
     const bookGroupDevId = 'ee211610-1156-2d0f-9e85-cdfea89d10f1-8b531d9f4fa15';
     const bookGroupLocalId = '9901127a-7db9-4552-a12a-10a1b2060a16-1661131213291';
     const thirdBookGroupLiveId = 'e1a34da3-a6a5-45e2-8aa2-b6ea9381e66e-1688392661899';
     const bookGroupIds = [bookGroupStagingId, bookGroupDevId, bookGroupLocalId, thirdBookGroupLiveId];
     const isBookGroup = bookGroupIds.includes(sellingGroup?.id);

     const certifiedReviewGroupLocalId = !isProductionEnv ? 'aacdbd00-7275-49cb-8ff5-87fe4adadd1e-1656016711733' : '';
     const certifiedReviewGroupDevId = !isProductionEnv ? 'aacdbd00-7275-49cb-8ff5-87fe4adadd1e-1656016711733' : '';
     const certifiedReviewGroupLiveId = '60ea7069-436c-4915-b6aa-036fc61d040b-1691184077924';
     const certifiedReviewGroupIds = [certifiedReviewGroupLocalId, certifiedReviewGroupDevId, certifiedReviewGroupLiveId];
     const isCertifiedReview = certifiedReviewGroupIds.includes(sellingGroup?.id);

     // const callGroupDevId = '1e97cc33-d798-40e5-b63c-36bc23d35213-1655999750087';
     // const callGroupLocalId = '86510ac3-db6f-4cee-a2d2-ce56cea63b5f-1676281692459';
     // const callGroupLiveId = '1e97cc33-d798-40e5-b63c-36bc23d35213-1655999750087';
     // const callGroupIds = [callGroupDevId, callGroupLocalId, callGroupLiveId];
     // const isCallGroup = callGroupIds.includes(sellingGroup?.id);

     return (
          <CCol md={6} xl={4}>
               <div className="selling-group-card-wrapper">
                    <div className="selling-group-card">
                         <div className="selling-group-card-top">
                              <div className="selling-group-card-header">
                                   {sellingGroup.headline && (
                                        <Link
                                             className="selling-group-card-title"
                                             to={GUEST_PATH.SELLING_GROUPS_DETAIL.replace(':slug', sellingGroup.slug)}
                                             onClick={handleClickExplore}
                                        >
                                             {sellingGroup.headline}
                                        </Link>
                                   )}
                                   {trainingMethods.length > 0 && (
                                        <div className="selling-group-card-category-wrapper">
                                             {trainingMethods.map((trainingMethod, index) => (
                                                  <div key={index} className="selling-group-card-category">
                                                       {trainingMethod}
                                                  </div>
                                             ))}
                                        </div>
                                   )}
                              </div>
                              <div className={classNames('selling-group-card-content', { 'full-content': isFullContent })}>
                                   <div
                                        ref={descriptionRef}
                                        className={classNames('selling-group-card-content-description', { 'full-description': isFullContent })}
                                        dangerouslySetInnerHTML={{ __html: sellingGroup.shortDescription }}
                                   />
                                   {showButtonView && (
                                        <div className="selling-group-card-content-view" onClick={handleClickViewContent}>
                                             {isFullContent ? <span>View Less</span> : <span>View More</span>}
                                             <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                  <path
                                                       d={isFullContent ? 'M12 10L8 6L4 10' : 'M4 6L8 10L12 6'}
                                                       stroke="currentColor"
                                                       strokeWidth="1.5"
                                                       strokeLinecap="round"
                                                       strokeLinejoin="round"
                                                  />
                                             </svg>
                                        </div>
                                   )}
                              </div>

                              <div
                                   className="selling-group-card-price"
                                   dangerouslySetInnerHTML={{
                                        __html: showPriceProductPage({ listProduct: sellingGroup.products, isBookGroup, isCertifiedReview }),
                                   }}
                              />
                         </div>

                         <div className="selling-group-card-bottom">
                              <Link
                                   className="btn btn-primary btn-primary-v2 selling-group-card-btn-purchase"
                                   to={GUEST_PATH.SELLING_GROUPS_DETAIL.replace(':slug', sellingGroup.slug)}
                                   onClick={handleClickExplore}
                              >
                                   <span>Purchase Options</span>
                                   <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                             d="M3.16699 7.33404V8.66737H11.167L7.50033 12.334L8.44699 13.2807L13.727 8.0007L8.44699 2.7207L7.50033 3.66737L11.167 7.33404H3.16699Z"
                                             fill="currentColor"
                                        />
                                   </svg>
                              </Link>
                         </div>
                    </div>
               </div>
          </CCol>
     );
};

export default SellingGroupCard;
